(function () {
  var selector = '[data-early-bird-offer]';
  var activeSelector = '[data-early-bird-active]';
  var expiredSelector = '[data-early-bird-expired]';
  var statusSelector = '[data-early-bird-status]';
  var statusTextSelector = '[data-early-bird-status-text]';
  var unitSelector = '[data-countdown-unit]';
  var valueSelector = '[data-countdown-value]';
  var announcementSelector = '[data-early-bird-announcement]';
  var chipValueSelector = '[data-countdown-chip-value]';
  var state = window.WellWiseEarlyBirdOffer || {
    intervalId: null
  };

  window.WellWiseEarlyBirdOffer = state;

  function getOffers() {
    return Array.prototype.slice.call(document.querySelectorAll(selector));
  }

  function getAnnouncements() {
    return Array.prototype.slice.call(document.querySelectorAll(announcementSelector));
  }

  function isCanonicalAnnouncement(announcement) {
    var siteHeader = document.querySelector('.site-header');
    var chipValue = announcement.querySelector(chipValueSelector);

    if (!siteHeader || !chipValue) {
      return false;
    }

    return Boolean(announcement.compareDocumentPosition(siteHeader) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function removeNoncanonicalAnnouncements() {
    getAnnouncements().forEach(function (announcement) {
      if (isCanonicalAnnouncement(announcement)) {
        return;
      }

      announcement.hidden = true;
      announcement.remove();
    });
  }

  function getDeadlineMs(offer) {
    var deadlineMs = Number(offer.getAttribute('data-deadline-ms'));

    if (!Number.isFinite(deadlineMs) || deadlineMs <= 0) {
      return null;
    }

    return deadlineMs;
  }

  function getStatusTextNode(status) {
    var statusText = status.querySelector(statusTextSelector);

    if (statusText) {
      return statusText;
    }

    statusText = document.createElement('span');
    statusText.setAttribute('data-early-bird-status-text', '');
    statusText.className = 'ww-visually-hidden';
    status.insertBefore(statusText, status.firstChild);

    return statusText;
  }

  function getCountdownValues(remainingMs) {
    var remainingSeconds = Math.floor(remainingMs / 1000);
    var days = Math.floor(remainingSeconds / 86400);
    var hours = Math.floor((remainingSeconds % 86400) / 3600);
    var minutes = Math.floor((remainingSeconds % 3600) / 60);
    var seconds = remainingSeconds % 60;

    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  }

  function padTwo(value) {
    return String(value).padStart(2, '0');
  }

  function formatCompactCountdown(values) {
    return values.days + 'd ' + padTwo(values.hours) + 'h ' + padTwo(values.minutes) + 'm ' + padTwo(values.seconds) + 's';
  }

  function formatCountdownText(label, values) {
    return label + ' ' + values.days + ' days ' + values.hours + ' hours ' + values.minutes + ' minutes remaining';
  }

  function setUnitText(offer, values) {
    offer.querySelectorAll(unitSelector).forEach(function (unit) {
      var unitName = unit.getAttribute('data-countdown-unit');
      var value = unit.querySelector(valueSelector);

      if (value) {
        if (unitName === 'days') {
          value.textContent = String(values[unitName] || 0);
        } else {
          value.textContent = padTwo(values[unitName] || 0);
        }
        return;
      }

      unit.textContent = String(values[unitName] || 0);
    });
  }

  function setExpiredState(offer, statusText, expiredHeading, expiredText) {
    var active = offer.querySelector(activeSelector);
    var expired = offer.querySelector(expiredSelector);
    var status = offer.querySelector(statusSelector);

    offer.classList.add('is-expired');

    if (active) {
      active.hidden = true;
    }

    if (expired) {
      expired.hidden = false;
    }

    if (statusText) {
      statusText.textContent = expiredHeading + ' ' + expiredText;
    }

    if (status) {
      status.setAttribute('aria-live', 'polite');
    }
  }

  function setActiveState(offer, statusText, activeLabel, values) {
    var active = offer.querySelector(activeSelector);
    var expired = offer.querySelector(expiredSelector);

    offer.classList.remove('is-expired');

    if (active) {
      active.hidden = false;
    }

    if (expired) {
      expired.hidden = true;
    }

    if (statusText) {
      var currentMinute = String(Math.floor(Date.now() / 60000));

      if (statusText.getAttribute('data-last-status-minute') !== currentMinute) {
        statusText.textContent = formatCountdownText(activeLabel, values);
        statusText.setAttribute('data-last-status-minute', currentMinute);
      }
    }
  }

  function refreshOffer(offer) {
    var deadlineMs = getDeadlineMs(offer);

    if (deadlineMs === null) {
      return false;
    }

    var status = offer.querySelector(statusSelector);

    if (!status) {
      return false;
    }

    var statusText = getStatusTextNode(status);
    var activeLabel = offer.getAttribute('data-active-label') || '';
    var expiredHeading = offer.getAttribute('data-expired-heading') || '';
    var expiredText = offer.getAttribute('data-expired-text') || '';
    var remainingMs = deadlineMs - Date.now();

    if (remainingMs <= 0) {
      setExpiredState(offer, statusText, expiredHeading, expiredText);
      return false;
    }

    var values = getCountdownValues(remainingMs);
    setUnitText(offer, values);
    setActiveState(offer, statusText, activeLabel, values);

    return true;
  }

  function tickAllOffers() {
    var offers = getOffers();
    var hasActiveCountdown = false;

    offers.forEach(function (offer) {
      if (refreshOffer(offer)) {
        hasActiveCountdown = true;
      }
    });

    return hasActiveCountdown;
  }

  function refreshAnnouncement(announcement) {
    var deadlineMs = getDeadlineMs(announcement);
    var nowMs = Date.now();

    if (deadlineMs === null || deadlineMs - nowMs <= 0) {
      announcement.hidden = true;
      return false;
    }

    var values = getCountdownValues(deadlineMs - nowMs);
    var chipValue = announcement.querySelector(chipValueSelector);

    announcement.hidden = false;

    if (chipValue) {
      chipValue.textContent = formatCompactCountdown(values);
    }

    return true;
  }

  function syncAnnouncements() {
    var hasActiveAnnouncement = false;

    removeNoncanonicalAnnouncements();

    getAnnouncements().forEach(function (announcement) {
      if (refreshAnnouncement(announcement)) {
        hasActiveAnnouncement = true;
      }
    });

    return hasActiveAnnouncement;
  }

  function init() {
    if (state.intervalId !== null) {
      window.clearInterval(state.intervalId);
      state.intervalId = null;
    }

    var hasActiveOffer = tickAllOffers();
    var hasActiveAnnouncement = syncAnnouncements();

    if (hasActiveOffer || hasActiveAnnouncement) {
      state.intervalId = window.setInterval(function () {
        hasActiveOffer = tickAllOffers();
        hasActiveAnnouncement = syncAnnouncements();

        if (!hasActiveOffer && !hasActiveAnnouncement && state.intervalId !== null) {
          window.clearInterval(state.intervalId);
          state.intervalId = null;
        }
      }, 1000);
    }
  }

  window.wellWiseEarlyBirdOfferInit = init;

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

  if (document.readyState !== 'loading') {
    init();
  }
})();
